// 2021 Topps Chrome Star Wars Legacy (released October 20, 2021)
// The second Chrome Legacy — story moments from the modern films and shows:
// The Rise of Skywalker, Rogue One, Solo, The Clone Wars, Rebels, and The
// Mandalorian seasons 1-2, all on chromium.
//
// Cards transcribed VERBATIM from the official Topps checklist
// (2021-Topps-Star-Wars-Chrome-Legacy-Checklist.xlsx via gogts.net) — including
// the official "PROJECT KYOTO CONCEPT ART" title for the Star Wars: Visions
// insert (the show's working title; Cardboard Connection renames it "Visions
// Concept Art", but the official name wins). Structure, parallels and print
// runs verified against Cardboard Connection × Beckett (agree throughout).
// Ship medallion base cards are serial /99 — Beckett's prose confirms the base
// is numbered, and eBay specimens (63/99, 99/99, 48/99, 92/99) supply the run.
// Base autographs are UNNUMBERED (both sources start the ladder at Blue /99).
// Dual autographs are serial numbered "/25 or less" (Beckett/CC) but NO source
// publishes per-card runs -> no serial slot modeled (Beskar MLA precedent).
// Sketch cards: 139-artist roster straight from the official checklist; the
// standard and shaped formats share the roster, so one row per artist.
//
// Box: 5 cards/pack x 12 packs (two 6-pack mini boxes), 8 boxes/case.
// 2 hits per box (1 autograph-or-sketch + 1 auto/sketch/medallion), 4 refractors.

const BASE_PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'blue-refractor', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
  { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
  { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black-refractor', name: 'Black Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
];

const INSERT_LADDER = [
  { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
  { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black-refractor', name: 'Black Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
];

// Base medallion is serial /99 (rule-6 slot; blank name renders as "/99").
const MEDALLION_PARALLELS = [
  { id: 'base', name: '', print_run: 99, color: '#c8d8f0' },
  ...INSERT_LADDER,
];

const AUTO_LADDER = [
  { id: 'blue-refractor', name: 'Blue Refractor', print_run: 99, color: '#2979ff' },
  { id: 'green-refractor', name: 'Green Refractor', print_run: 50, color: '#00e676' },
  { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black-refractor', name: 'Black Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'SuperFractor', print_run: 1, color: '#f0c040' },
];

export const SETS = [
  {
    id: 'base-cards', type: 'base', title: 'BASE CARDS — 200 CARDS', parallels: BASE_PARALLELS,
    cards: [
      {n:'1', name:'Kylo Ren Obtains The Sith Wayfinder'},
      {n:'2', name:'Kylo Ren Finds Palpatine On Exegol'},
      {n:'3', name:'Palpatine Reveals The Final Order'},
      {n:'4', name:'Rey In Training'},
      {n:'5', name:'Finn And Poe Deliver Intelligence'},
      {n:'6', name:'Lando Calrissian Helps The Resistance'},
      {n:'7', name:'Chewbacca Taken By The First Order'},
      {n:'8', name:'Rey And The Team Travel To Kijimi'},
      {n:'9', name:'C-3PO\'s Memory Reveals The Wayfinder'},
      {n:'10', name:'Rey Learns Who She Is'},
      {n:'11', name:'The Team Rescues Chewbacca'},
      {n:'12', name:'The Falcon Flies To Kef Bir'},
      {n:'13', name:'Rey & Kylo Ren Battle Amongst The Waves'},
      {n:'14', name:'Rey Heals Kylo Ren'},
      {n:'15', name:'Luke Skywalker Tells Rey To Face Palpatine'},
      {n:'16', name:'Ben Solo Sees A Memory Of Han Solo'},
      {n:'17', name:'The Resistance Prepares To Attack'},
      {n:'18', name:'Rey Confronts Her Grandfather'},
      {n:'19', name:'Lando Calrissian Brings Reinforcements'},
      {n:'20', name:'Ben Solo Destroys The Knights Of Ren'},
      {n:'21', name:'Ben Solo And Rey Take On Palpatine'},
      {n:'22', name:'Palpatine Drains Power From Rey And Ben Solo'},
      {n:'23', name:'The Fleet Attacked By Force Lightning'},
      {n:'24', name:'Rey Hears The Voices Of Past Jedi'},
      {n:'25', name:'Rey Deflects The Force Lightning'},
      {n:'26', name:'Palpatine Is Destroyed By Rey'},
      {n:'27', name:'Ben Solo Uses The Force To Revive Rey'},
      {n:'28', name:'The Resistance Defeats The Final Order'},
      {n:'29', name:'Rey Buries The Lightsabers On Tatooine'},
      {n:'30', name:'Rey States Her Name As "Rey Skywalker"'},
      {n:'31', name:'Director Krennic Finds Galen Erso'},
      {n:'32', name:'Young Jyn Erso Escapes The Empire'},
      {n:'33', name:'Bodhi Rook Flees The Empire'},
      {n:'34', name:'Cassian Learns Of An Imperial Defector'},
      {n:'35', name:'Jyn Erso Meets Mon Mothma'},
      {n:'36', name:'Jyn & Cassian Team With K-2SO'},
      {n:'37', name:'Chirrut & Baze Battle The Stormtroopers'},
      {n:'38', name:'Saw Gerrera Reveals The Message From Galen Erso'},
      {n:'39', name:'Director Krennic Destroys Jedha City'},
      {n:'40', name:'Grand Moff Tarkin Meets With Director Krennic'},
      {n:'41', name:'Bodhi Rook Leads The Team To Eadu'},
      {n:'42', name:'Jyn Erso Is Too Late To Save Her Father'},
      {n:'43', name:'Director Krennic Talks With Darth Vader'},
      {n:'44', name:'The Mission To Steal The Death Star Plans'},
      {n:'45', name:'Rogue One Heads To Scarif'},
      {n:'46', name:'Cassian, Jyn & K-2SO Sneak Into The Base'},
      {n:'47', name:'Admiral Raddus Defeats The Star Destroyers'},
      {n:'48', name:'Cassian & Jyn Find The Schematics'},
      {n:'49', name:'Director Krennic Ambushes Jyn & Cassian'},
      {n:'50', name:'Jyn Transmits The Death Star Plans'},
      {n:'51', name:'Tarkin Destroys The Compromised Base'},
      {n:'52', name:'The Rebel Fleet Prepares For Hyperspace'},
      {n:'53', name:'Vader\'s Destroyer Intercepts Rebels'},
      {n:'54', name:'Vader Pursues The Stolen Plans'},
      {n:'55', name:'Darth Vader Attacks The Rebels'},
      {n:'56', name:'Rebels Fight To Hand Off The Stolen Plans'},
      {n:'57', name:'A Small Starship Evades Vader\'s Grasp'},
      {n:'58', name:'The Plans Are Delivered To Princess Leia'},
      {n:'59', name:'The Rebellion Now Has Hope'},
      {n:'60', name:'Han & Qi\'ra Run From The White Worms'},
      {n:'61', name:'Qi\'ra Is Captured During Escape Attempt'},
      {n:'62', name:'Han Escapes, But Vows To Return'},
      {n:'63', name:'Han Encounters Tobias Beckett'},
      {n:'64', name:'Solo Meets Chewbacca In The Pit'},
      {n:'65', name:'Beckett Teams With Solo & Chewie'},
      {n:'66', name:'Beckett & The Team Try To Steal Coaxium'},
      {n:'67', name:'Enfys Nest Ruins The Hijacking Plans'},
      {n:'68', name:'Beckett Loses Val & Rio Durant'},
      {n:'69', name:'Han & Chewie Vow To Help Beckett'},
      {n:'70', name:'Han Finds Qi\'ra With Crimson Dawn'},
      {n:'71', name:'The Team Meets With Dryden Vos'},
      {n:'72', name:'Han Suggests Kessel Run To Obtain Coaxium'},
      {n:'73', name:'Qi\'ra Brings The Team To Lando Calrissian'},
      {n:'74', name:'Han Challenges Lando To Sabacc'},
      {n:'75', name:'Lando Joins The Mission For A Share Of Profits'},
      {n:'76', name:'Han Solo Sees The Millennium Falcon'},
      {n:'77', name:'L3-37 Instigates Revolt On Kessel'},
      {n:'78', name:'The Team Steals The Coaxium & Flees The Empire'},
      {n:'79', name:'The Millennium Falcon Lands On Savareen'},
      {n:'80', name:'Enfys Nest Reveals Her Crew To Be Rebels'},
      {n:'81', name:'Han Attempts To Outsmart Dryden Vos'},
      {n:'82', name:'Beckett Betrays Dryden Vos, Takes Chewie'},
      {n:'83', name:'Qi\'ra Defeats Dryden Vos'},
      {n:'84', name:'Han Goes After Beckett'},
      {n:'85', name:'Qi\'ra Contacts Maul'},
      {n:'86', name:'Han Defeats Beckett'},
      {n:'87', name:'Han Gives The Coaxium To Enfys Nest'},
      {n:'88', name:'Han Wins The Millennium Falcon From Lando'},
      {n:'89', name:'Master Yoda Begins A Secret Mission'},
      {n:'90', name:'Yoda Takes On Ventress And Her Army'},
      {n:'91', name:'The Toydarian People Learn About The Jedi'},
      {n:'92', name:'The Malevolence Wreaks Havoc On The Jedi'},
      {n:'93', name:'The Jedi Take Down The Malevolence'},
      {n:'94', name:'Cad Bane & Aurra Sing Attack Senate Building'},
      {n:'95', name:'Darth Sidious Hires Cad Bane'},
      {n:'96', name:'Cad Bane Goes For The Jedi Holocron'},
      {n:'97', name:'Obi-Wan Kenobi Meets With Duchess Satine'},
      {n:'98', name:'Ahsoka Tano Stops Aurra Sing On Florrum'},
      {n:'99', name:'Boba Fett & Bossk Are Arrested'},
      {n:'100', name:'Ahsoka Tano Protects Senator Amidala'},
      {n:'101', name:'Cad Bane Breaks Ziro From Prison'},
      {n:'102', name:'Darth Sidious Meets With Count Dooku'},
      {n:'103', name:'The Jedi Descend On Mortis'},
      {n:'104', name:'Chewbacca Helps Ahsoka Escape'},
      {n:'105', name:'Krell And Dooku Become Allies'},
      {n:'106', name:'Lux & Ahsoka Tano Escape From Vizsla'},
      {n:'107', name:'Obi-Wan Kenobi Battles Maul & Savage Opress'},
      {n:'108', name:'Anakin Skywalker Contacts Hondo Ohnaka'},
      {n:'109', name:'Yoda Teaches Younglings On Ilum'},
      {n:'110', name:'Mandalore Under Attack'},
      {n:'111', name:'Order 66 Is Activated'},
      {n:'112', name:'Ahsoka Tano & Captain Rex Try To Stop Maul'},
      {n:'113', name:'Darth Vader Finds Ahsoka Tano\'s Lightsaber'},
      {n:'114', name:'Ezra Bridger Joins Ghost Crew In Their Getaway'},
      {n:'115', name:'Zeb Orrelios Hijacks A Tie Fighter'},
      {n:'116', name:'Ezra Bridger Starts His Jedi Training'},
      {n:'117', name:'Kanan Jarrus Struggles As A Mentor'},
      {n:'118', name:'Grand Moff Tarkin Visits Lothal'},
      {n:'119', name:'Agent Kallus Meets Darth Vader'},
      {n:'120', name:'Darth Vader Attacks Lothal'},
      {n:'121', name:'The Ghost Crew Locates Captain Rex'},
      {n:'122', name:'Ezra Bridger & Chopper Find Ketsu Onyo'},
      {n:'123', name:'Ahsoka Tano Meets With Kanan'},
      {n:'124', name:'Ezra Learns About His Parents'},
      {n:'125', name:'Leia Talks With Ezra & Kanan'},
      {n:'126', name:'Chava Reveals The True Force Names'},
      {n:'127', name:'Ezra Bridger Opens The Sith Holocron'},
      {n:'128', name:'Kanan Jarrus Rescues The Ghost Crew'},
      {n:'129', name:'Obi-Wan Kenobi Watches A Young Luke Skywalker'},
      {n:'130', name:'Ezra & Sabine Destroy Interdictor-Class Cruisers'},
      {n:'131', name:'Kanan Jarrus Uses The Force To Control The Blast'},
      {n:'132', name:'Sabine Wren & Zeb Orrelios Take On Rukh'},
      {n:'133', name:'Ahsoka Tano\'s Final Battle With Darth Vader'},
      {n:'134', name:'The Plan To Liberate Lothal'},
      {n:'135', name:'The Imperials Are Defeated'},
      {n:'136', name:'The Command Center Is Destroyed'},
      {n:'137', name:'The People Of Lothal Celebrate'},
      {n:'138', name:'The Ghost Crew Go Their Separate Ways'},
      {n:'139', name:'Hera & Rex Remain With The Rebels'},
      {n:'140', name:'The Mural Of The Ghost Crew On Lothal'},
      {n:'141', name:'Mando Meets With Greef Karga'},
      {n:'142', name:'Mando Accepts A New Mission'},
      {n:'143', name:'Grogu Is Discovered By Mando'},
      {n:'144', name:'Kuiil Helps Mando Negotiate'},
      {n:'145', name:'Grogu Uses The Force'},
      {n:'146', name:'Mando Hands Over Grogu'},
      {n:'147', name:'Mando Rescues Grogu From The Lab'},
      {n:'148', name:'Mando & Grogu Land On Tatooine'},
      {n:'149', name:'Mando Takes A Job From Ranzar Malk'},
      {n:'150', name:'The Team Tries To Capture Mando'},
      {n:'151', name:'X-Wings Attack Ranzar Malk\'s Station'},
      {n:'152', name:'Grogu Force Heals Greef Karga'},
      {n:'153', name:'Moff Gideon Arrives On Nevarro'},
      {n:'154', name:'Troops Fire On Mando\'s Crew'},
      {n:'155', name:'Moff Gideon Demands Grogu'},
      {n:'156', name:'Troopers Take Grogu From Kuiil'},
      {n:'157', name:'IG-11 Rescues Grogu'},
      {n:'158', name:'Mando Is Injured In Battle'},
      {n:'159', name:'IG-11 Removes Mando\'s Helmet'},
      {n:'160', name:'The Armorer Is The Only One Left'},
      {n:'161', name:'Mando Is Told To Bring Grogu To The Jedi'},
      {n:'162', name:'The Team Escapes On A Lava River Ferry'},
      {n:'163', name:'Troopers Ambush The Tunnel Exit'},
      {n:'164', name:'IG-11 Saves The Team By Self-Destructing'},
      {n:'165', name:'Moff Gideon Attacks In A Tie Fighter'},
      {n:'166', name:'Mando Takes Down The Tie Fighter'},
      {n:'167', name:'Mando Embarks On A New Mission'},
      {n:'168', name:'Moff Gideon Survives The Crash'},
      {n:'169', name:'Moff Gideon Ignites The Darksaber'},
      {n:'170', name:'Mando And Grogu Fly Away'},
      {n:'171', name:'Mando Meets The Marshal'},
      {n:'172', name:'The Krayt Dragon Attacks'},
      {n:'173', name:'The Krayt Dragon Slain By Mando'},
      {n:'174', name:'The Frog Lady Meets Grogu'},
      {n:'175', name:'The Razor Crest Is Attacked By Spiders'},
      {n:'176', name:'The New Republic Saves The Razor Crest'},
      {n:'177', name:'Mando Meets Other Mandalorians'},
      {n:'178', name:'Bo-Katan Kryze Offers Mando A Job'},
      {n:'179', name:'Mando Lands On Nevarro'},
      {n:'180', name:'The Imperial Base Is Destroyed'},
      {n:'181', name:'Ahsoka Tano Meets Grogu'},
      {n:'182', name:'Ahsoka & Mando Defeat Morgan Elsbeth'},
      {n:'183', name:'Grogu\'s Bond With Mando'},
      {n:'184', name:'Ahsoka Gives The Spear To Mando'},
      {n:'185', name:'Mando Brings Grogu To Tython'},
      {n:'186', name:'Grogu On The Seeing Stone'},
      {n:'187', name:'Boba Fett & Fennec Shand Arrive'},
      {n:'188', name:'Mando, Fett & Shand Battle Troopers'},
      {n:'189', name:'Dark Troopers Take Grogu'},
      {n:'190', name:'Mayfeld & Mando Work Together'},
      {n:'191', name:'Pirates Attack The Rhydonium'},
      {n:'192', name:'Mando Takes Off His Helmet For The Code'},
      {n:'193', name:'Dr. Pershing Is Captured'},
      {n:'194', name:'Mando Asks For Help On His Mission'},
      {n:'195', name:'Crash Landing On Moff Gideon\'s Cruiser'},
      {n:'196', name:'Stormtrooper Battle On The Bridge'},
      {n:'197', name:'Mando Beats Gideon & The Darksaber'},
      {n:'198', name:'Luke Skywalker Destroys The Dark Troopers'},
      {n:'199', name:'Grogu Meets Luke Skywalker & R2-D2'},
      {n:'200', name:'Mando Says Good-Bye To Grogu'},
    ]
  },
  {
    id: 'mandalorian-concept-art', type: 'insert', title: 'MANDALORIAN CONCEPT ART — 15 CARDS', parallels: INSERT_LADDER,
    cards: [
      {n:'MCA-1', name:'Doug Chiang, John Park', artist:'Season 1, Episode 1'},
      {n:'MCA-2', name:'Doug Chiang', artist:'Season 1, Episode 2'},
      {n:'MCA-3', name:'Brian Matyas', artist:'Season 1, Episode 3'},
      {n:'MCA-4', name:'Christian Alzmann', artist:'Season 1, Episode 4'},
      {n:'MCA-5', name:'Christian Alzmann', artist:'Season 1, Episode 5'},
      {n:'MCA-6', name:'Doug Chiang', artist:'Season 2, Episode 1'},
      {n:'MCA-7', name:'Brian Matyas', artist:'Season 2, Episode 1'},
      {n:'MCA-8', name:'Christian Alzmann', artist:'Season 2, Episode 2'},
      {n:'MCA-9', name:'Brian Matyas', artist:'Season 2, Episode 3'},
      {n:'MCA-10', name:'Ryan Church', artist:'Season 2, Episode 4'},
      {n:'MCA-11', name:'Christian Alzmann', artist:'Season 2, Episode 5'},
      {n:'MCA-12', name:'Christian Alzmann', artist:'Season 2, Episode 5'},
      {n:'MCA-13', name:'Ryan Church', artist:'Season 2, Episode 6'},
      {n:'MCA-14', name:'Christian Alzmann', artist:'Season 2, Episode 6'},
      {n:'MCA-15', name:'Brian Matyas', artist:'Season 2, Episode 7'},
    ]
  },
  {
    id: 'wielders-of-the-lightsaber', type: 'insert', title: 'WIELDERS OF THE LIGHTSABER — 20 CARDS', parallels: INSERT_LADDER,
    cards: [
      {n:'WL-1', name:'Luke Skywalker'},
      {n:'WL-2', name:'Anakin Skywalker'},
      {n:'WL-3', name:'Darth Vader'},
      {n:'WL-4', name:'Darth Sidious'},
      {n:'WL-5', name:'Darth Maul'},
      {n:'WL-6', name:'Count Dooku'},
      {n:'WL-7', name:'Kylo Ren'},
      {n:'WL-8', name:'Rey'},
      {n:'WL-9', name:'Finn'},
      {n:'WL-10', name:'Ahsoka Tano'},
      {n:'WL-11', name:'Kanan Jarrus'},
      {n:'WL-12', name:'Ezra Bridger'},
      {n:'WL-13', name:'Yoda'},
      {n:'WL-14', name:'Mace Windu'},
      {n:'WL-15', name:'Obi-Wan Kenobi'},
      {n:'WL-16', name:'Qui-Gon Jinn'},
      {n:'WL-17', name:'General Grievous'},
      {n:'WL-18', name:'Kit Fisto'},
      {n:'WL-19', name:'The Grand Inquisitor'},
      {n:'WL-20', name:'Seventh Sister'},
    ]
  },
  {
    id: 'project-kyoto-concept-art', type: 'insert', title: 'PROJECT KYOTO CONCEPT ART — 15 CARDS', parallels: INSERT_LADDER,
    cards: [
      {n:'SWV-1', name:'The Duel'},
      {n:'SWV-2', name:'Lop & Ochō'},
      {n:'SWV-3', name:'Lop & Ochō'},
      {n:'SWV-4', name:'The Duel'},
      {n:'SWV-5', name:'The Duel'},
      {n:'SWV-6', name:'The Duel'},
      {n:'SWV-7', name:'Tatooine Rhapsody'},
      {n:'SWV-8', name:'Tatooine Rhapsody'},
      {n:'SWV-9', name:'The Ninth Jedi'},
      {n:'SWV-10', name:'Tatooine Rhapsody'},
      {n:'SWV-11', name:'Tatooine Rhapsody'},
      {n:'SWV-12', name:'The Ninth Jedi'},
      {n:'SWV-13', name:'Lop & Ochō'},
      {n:'SWV-14', name:'Tatooine Rhapsody'},
      {n:'SWV-15', name:'T0-B1'},
    ]
  },
  {
    id: 'commemorative-ship-medallions', type: 'insert', title: 'COMMEMORATIVE SHIP MEDALLION CARDS — 40 CARDS (/99)', parallels: MEDALLION_PARALLELS,
    cards: [
      {n:'SM-GE', name:'Galen Erso'},
      {n:'SM-DK', name:'Director Krennic'},
      {n:'SM-JE', name:'Jyn Erso'},
      {n:'SM-BR', name:'Bodhi Rook'},
      {n:'SM-SG', name:'Saw Gerrera'},
      {n:'SM-CA', name:'Captain Cassian Andor'},
      {n:'SM-K2', name:'K-2SO'},
      {n:'SM-CI', name:'Chirrut Îmwe'},
      {n:'SM-BM', name:'Baze Malbus'},
      {n:'SM-MT', name:'Grand Moff Tarkin'},
      {n:'SM-DV', name:'Darth Vader'},
      {n:'SM-HS', name:'Han Solo'},
      {n:'SM-LS', name:'Luke Skywalker'},
      {n:'SM-LO', name:'Princess Leia Organa'},
      {n:'SM-C3', name:'C-3PO'},
      {n:'SM-C', name:'Chewbacca'},
      {n:'SM-R2', name:'R2-D2'},
      {n:'SM-LC', name:'Lando Calrissian'},
      {n:'SM-DVD', name:'Darth Vader'},
      {n:'SM-SD', name:'Stormtrooper'},
      {n:'SM-GVD', name:'General Veers'},
      {n:'SM-DVT', name:'Darth Vader'},
      {n:'SM-JVT', name:'Jon "Dutch" Vander'},
      {n:'SM-LST', name:'Luke Skywalker'},
      {n:'SM-BKT', name:'Biggs Darklighter'},
      {n:'SM-WAT', name:'Wedge Antilles'},
      {n:'SM-TIE', name:'TIE Fighter Pilot'},
      {n:'SM-KRT', name:'Kylo Ren'},
      {n:'SM-PDT', name:'Poe Dameron'},
      {n:'SM-FT', name:'Finn'},
      {n:'SM-RT', name:'Rey'},
      {n:'SM-BBT', name:'BB-8'},
      {n:'SM-LSX', name:'Luke Skywalker'},
      {n:'SM-PDX', name:'Poe Dameron'},
      {n:'SM-WAX', name:'Wedge Antilles'},
      {n:'SM-JPX', name:'Jess "Testor" Pava'},
      {n:'SM-SWX', name:'Snap Wexley'},
      {n:'SM-NNX', name:'Nien Nunb'},
      {n:'SM-EAX', name:'Ello Asty'},
      {n:'SM-TLX', name:'Tallie Lintra'},
    ]
  },
  {
    id: 'age-of-republic-autographs', type: 'auto', title: 'AGE OF REPUBLIC AUTOGRAPHS — 10 CARDS', parallels: AUTO_LADDER,
    cards: [
      {n:'ARP-AB', name:'Ahmed Best'},
      {n:'ARP-AE', name:'Ashley Eckstein'},
      {n:'ARP-DL', name:'Daniel Logan'},
      {n:'ARP-DT', name:'David Tennant'},
      {n:'ARP-EM', name:'Ewan McGregor'},
      {n:'ARP-HC', name:'Hayden Christensen'},
      {n:'ARP-JAT', name:'James Arnold Taylor'},
      {n:'ARP-LM', name:'Lewis Macleod'},
      {n:'ARP-RP', name:'Ron Perlman'},
      {n:'ARP-SLJ', name:'Samuel L. Jackson'},
    ]
  },
  {
    id: 'age-of-rebellion-autographs', type: 'auto', title: 'AGE OF REBELLION AUTOGRAPHS — 25 CARDS', parallels: AUTO_LADDER,
    cards: [
      {n:'ARB-JM', name:'John Morton'},
      {n:'ARB-PR', name:'Pam Rose'},
      {n:'ARB-MB', name:'Mark Boone Jr.'},
      {n:'ARB-MP', name:'Michael Pennington'},
      {n:'ARB-DC', name:'Dermot Crowley'},
      {n:'ARB-MQ', name:'Mike Quinn'},
      {n:'ARB-JB', name:'Jeremy Bulloch'},
      {n:'ARB-GE', name:'Giancarlo Esposito'},
      {n:'ARB-MC', name:'Michael Carter'},
      {n:'ARB-PM', name:'Peter Mayhew'},
      {n:'ARB-AT', name:'Alan Tudyk'},
      {n:'ARB-KB', name:'Ben Burtt'},
      {n:'ARB-BM', name:'Ben Mendelsohn'},
      {n:'ARB-DY', name:'Donnie Yen'},
      {n:'ARB-RA', name:'Riz Ahmed'},
      {n:'ARB-MM', name:'Mads Mikkelsen'},
      {n:'ARB-NN', name:'Nick Nolte'},
      {n:'ARB-RD', name:'Rosario Dawson'},
      {n:'ARB-TW', name:'Taika Waititi'},
      {n:'ARB-IM', name:'Ian McDiarmid'},
      {n:'ARB-FW', name:'Forest Whitaker'},
      {n:'ARB-WH', name:'Werner Herzog'},
      {n:'ARB-BDW', name:'Billy Dee Williams'},
      {n:'ARB-FJ', name:'Felicity Jones'},
      {n:'ARB-HF', name:'Harrison Ford'},
    ]
  },
  {
    id: 'age-of-resistance-autographs', type: 'auto', title: 'AGE OF RESISTANCE AUTOGRAPHS — 18 CARDS', parallels: AUTO_LADDER,
    cards: [
      {n:'ARS-EE', name:'Emun Elliott'},
      {n:'ARS-DC', name:'Dave Chapman'},
      {n:'ARS-TW', name:'Tom Wilton'},
      {n:'ARS-MQ', name:'Mike Quinn'},
      {n:'ARS-KL', name:'Ken Leung'},
      {n:'ARS-GG', name:'Greg Grunberg'},
      {n:'ARS-JB', name:'John Boyega'},
      {n:'ARS-NA', name:'Naomi Ackie'},
      {n:'ARS-DM', name:'Dominic Monaghan'},
      {n:'ARS-AS', name:'Andy Serkis'},
      {n:'ARS-KB', name:'Kenny Baker'},
      {n:'ARS-BDW', name:'Billy Dee Williams'},
      {n:'ARS-GC', name:'Gwendoline Christie'},
      {n:'ARS-CF', name:'Carrie Fisher'},
      {n:'ARS-AD', name:'Adam Driver'},
      {n:'ARS-DG', name:'Domhnall Gleeson'},
      {n:'ARS-DR', name:'Daisy Ridley'},
      {n:'ARS-HF', name:'Harrison Ford'},
    ]
  },
  {
    // Serial numbered "/25 or less" (Beckett x Cardboard Connection), but no
    // source publishes per-card runs -> no serial slot (Beskar MLA precedent).
    id: 'dual-autographs', type: 'auto', title: 'DUAL AUTOGRAPHS — 5 CARDS', parallels: [],
    cards: [
      {n:'DA-BA', name:'John Boyega / Naomi Ackie'},
      {n:'DA-FR', name:'Carrie Fisher / Daisy Ridley'},
      {n:'DA-FM', name:'Harrison Ford / Peter Mayhew'},
      {n:'DA-MJ', name:'Ewan McGregor / Samuel L. Jackson'},
      {n:'DA-RQ', name:'Deep Roy / Mike Quinn'},
    ]
  },
  {
    // 139-artist roster from the official checklist. Standard and shaped
    // formats share the roster — one row per artist, all 1/1 originals.
    id: 'sketch-cards', type: 'sketch', title: 'SKETCH CARDS — 139 ARTISTS', parallels: [],
    cards: [
      {n:'1', name:'Sketch Card', artist:'Adam Beck'},
      {n:'2', name:'Sketch Card', artist:'Adam Worton'},
      {n:'3', name:'Sketch Card', artist:'Alex Mines'},
      {n:'4', name:'Sketch Card', artist:'Alexander Connell'},
      {n:'5', name:'Sketch Card', artist:'Allen Grimes'},
      {n:'6', name:'Sketch Card', artist:'Andrew Fry'},
      {n:'7', name:'Sketch Card', artist:'Andrew Perkins'},
      {n:'8', name:'Sketch Card', artist:'Andrew Sanchez'},
      {n:'9', name:'Sketch Card', artist:'Angel Aviles'},
      {n:'10', name:'Sketch Card', artist:'Angelina Benedetti'},
      {n:'11', name:'Sketch Card', artist:'Anil Sharma'},
      {n:'12', name:'Sketch Card', artist:'Antni Ellison'},
      {n:'13', name:'Sketch Card', artist:'Ashlee Brienzo'},
      {n:'14', name:'Sketch Card', artist:'Ashley Marsh'},
      {n:'15', name:'Sketch Card', artist:'Barry Renshaw'},
      {n:'16', name:'Sketch Card', artist:'Başak Çetinkaya'},
      {n:'17', name:'Sketch Card', artist:'Benjamin Lombart'},
      {n:'18', name:'Sketch Card', artist:'Bob Stevlic'},
      {n:'19', name:'Sketch Card', artist:'Bobby Blakey'},
      {n:'20', name:'Sketch Card', artist:'Brad Hudson'},
      {n:'21', name:'Sketch Card', artist:'Brandon Blevins'},
      {n:'22', name:'Sketch Card', artist:'Brent Ragland'},
      {n:'23', name:'Sketch Card', artist:'Brent Scotchmer'},
      {n:'24', name:'Sketch Card', artist:'Brett Farr'},
      {n:'25', name:'Sketch Card', artist:'Candice Dailey'},
      {n:'26', name:'Sketch Card', artist:'Carlos Cabaleiro'},
      {n:'27', name:'Sketch Card', artist:'Carolyn Craggs'},
      {n:'28', name:'Sketch Card', artist:'Chris Colyer'},
      {n:'29', name:'Sketch Card', artist:'Chris Kay'},
      {n:'30', name:'Sketch Card', artist:'Cyrus Sherkat'},
      {n:'31', name:'Sketch Card', artist:'Dan Gorman'},
      {n:'32', name:'Sketch Card', artist:'Dan Lawler'},
      {n:'33', name:'Sketch Card', artist:'Dan Tearle'},
      {n:'34', name:'Sketch Card', artist:'Daniel Riveron'},
      {n:'35', name:'Sketch Card', artist:'Darren James'},
      {n:'36', name:'Sketch Card', artist:'Darrin Pepe'},
      {n:'37', name:'Sketch Card', artist:'Dave Fowler'},
      {n:'38', name:'Sketch Card', artist:'Dawn Murphy'},
      {n:'39', name:'Sketch Card', artist:'Dean Drummond'},
      {n:'40', name:'Sketch Card', artist:'Don Pedicini Jr.'},
      {n:'41', name:'Sketch Card', artist:'Dwayne Carpenter'},
      {n:'42', name:'Sketch Card', artist:'Eric Lehtonen'},
      {n:'43', name:'Sketch Card', artist:'Erik Maell'},
      {n:'44', name:'Sketch Card', artist:'Francisco Rivera'},
      {n:'45', name:'Sketch Card', artist:'Frank Kader'},
      {n:'46', name:'Sketch Card', artist:'Frank Sansone'},
      {n:'47', name:'Sketch Card', artist:'Gabe Farber'},
      {n:'48', name:'Sketch Card', artist:'Garrett Dix'},
      {n:'49', name:'Sketch Card', artist:'Gavin Williams'},
      {n:'50', name:'Sketch Card', artist:'Gerard Garcia Jr.'},
      {n:'51', name:'Sketch Card', artist:'Gorkem Demir'},
      {n:'52', name:'Sketch Card', artist:'Huy Truong'},
      {n:'53', name:'Sketch Card', artist:'Ingrid Hardy'},
      {n:'54', name:'Sketch Card', artist:'Jake Minor'},
      {n:'55', name:'Sketch Card', artist:'Jamie Cosley'},
      {n:'56', name:'Sketch Card', artist:'Jamie Murdock'},
      {n:'57', name:'Sketch Card', artist:'Jamie Richards'},
      {n:'58', name:'Sketch Card', artist:'Jason Adams'},
      {n:'59', name:'Sketch Card', artist:'Jason Davies'},
      {n:'60', name:'Sketch Card', artist:'Jason Montoya'},
      {n:'61', name:'Sketch Card', artist:'Jason Queen'},
      {n:'62', name:'Sketch Card', artist:'Jason Sobol'},
      {n:'63', name:'Sketch Card', artist:'Jay Manchand'},
      {n:'64', name:'Sketch Card', artist:'Jeff Abar'},
      {n:'65', name:'Sketch Card', artist:'Jerold Bahr'},
      {n:'66', name:'Sketch Card', artist:'Jessica Hickman'},
      {n:'67', name:'Sketch Card', artist:'Jim Dickson'},
      {n:'68', name:'Sketch Card', artist:'Jim Mehsling'},
      {n:'69', name:'Sketch Card', artist:'JM Smith'},
      {n:'70', name:'Sketch Card', artist:'Joe Corroney'},
      {n:'71', name:'Sketch Card', artist:'John Bruce'},
      {n:'72', name:'Sketch Card', artist:'John Pleak'},
      {n:'73', name:'Sketch Card', artist:'Jonathan Beistline'},
      {n:'74', name:'Sketch Card', artist:'Jonty Gates'},
      {n:'75', name:'Sketch Card', artist:'Joshua Caleb King'},
      {n:'76', name:'Sketch Card', artist:'Jude Gallagher'},
      {n:'77', name:'Sketch Card', artist:'Karl Jones'},
      {n:'78', name:'Sketch Card', artist:'Keith Farnum'},
      {n:'79', name:'Sketch Card', artist:'Kelly Baber'},
      {n:'80', name:'Sketch Card', artist:'Kevin Cleveland'},
      {n:'81', name:'Sketch Card', artist:'Kevin Graham'},
      {n:'82', name:'Sketch Card', artist:'Kevin P. West'},
      {n:'83', name:'Sketch Card', artist:'Kursat Cetiner'},
      {n:'84', name:'Sketch Card', artist:'Lindsey Greyling'},
      {n:'85', name:'Sketch Card', artist:'Logan Monette'},
      {n:'86', name:'Sketch Card', artist:'Lucas Peverill'},
      {n:'87', name:'Sketch Card', artist:'Madison Emerick'},
      {n:'88', name:'Sketch Card', artist:'Maggie Ransom'},
      {n:'89', name:'Sketch Card', artist:'Marcia Dye'},
      {n:'90', name:'Sketch Card', artist:'Mark Necchi'},
      {n:'91', name:'Sketch Card', artist:'Marlo Agunos'},
      {n:'92', name:'Sketch Card', artist:'Marsha Parkins'},
      {n:'93', name:'Sketch Card', artist:'Matt Stewart'},
      {n:'94', name:'Sketch Card', artist:'Matthew Hirons'},
      {n:'95', name:'Sketch Card', artist:'Matthew Sutton'},
      {n:'96', name:'Sketch Card', artist:'Mayumi Seto'},
      {n:'97', name:'Sketch Card', artist:'Michael Mastermaker'},
      {n:'98', name:'Sketch Card', artist:'Michael Munshaw'},
      {n:'99', name:'Sketch Card', artist:'Michelle Rayner'},
      {n:'100', name:'Sketch Card', artist:'Mick and Matt Glebe'},
      {n:'101', name:'Sketch Card', artist:'Mike Stephens'},
      {n:'102', name:'Sketch Card', artist:'Mohammad Jilani'},
      {n:'103', name:'Sketch Card', artist:'Neil Camera'},
      {n:'104', name:'Sketch Card', artist:'Nick Allsopp'},
      {n:'105', name:'Sketch Card', artist:'Nick Gribbon'},
      {n:'106', name:'Sketch Card', artist:'Norviento Basio'},
      {n:'107', name:'Sketch Card', artist:'Oscar Chavez'},
      {n:'108', name:'Sketch Card', artist:'Patricio Carrasco'},
      {n:'109', name:'Sketch Card', artist:'Patrick Giles'},
      {n:'110', name:'Sketch Card', artist:'Paul Maitland'},
      {n:'111', name:'Sketch Card', artist:'Paul Shiers'},
      {n:'112', name:'Sketch Card', artist:'Phillip Trujillo'},
      {n:'113', name:'Sketch Card', artist:'Rees Finlay'},
      {n:'114', name:'Sketch Card', artist:'Rich Hennemann'},
      {n:'115', name:'Sketch Card', artist:'Rich Molinelli'},
      {n:'116', name:'Sketch Card', artist:'RJ Tomascik'},
      {n:'117', name:'Sketch Card', artist:'Rob Teranishi'},
      {n:'118', name:'Sketch Card', artist:'Robert Garcia'},
      {n:'119', name:'Sketch Card', artist:'Robert Hendrickson'},
      {n:'120', name:'Sketch Card', artist:'Rodney Roberts'},
      {n:'121', name:'Sketch Card', artist:'Rutvig Vaid'},
      {n:'122', name:'Sketch Card', artist:'Ryan Finley'},
      {n:'123', name:'Sketch Card', artist:'Ryan Santos'},
      {n:'124', name:'Sketch Card', artist:'Sammy Gomez'},
      {n:'125', name:'Sketch Card', artist:'Scott Robinson'},
      {n:'126', name:'Sketch Card', artist:'Semra Bulut'},
      {n:'127', name:'Sketch Card', artist:'Seth Groves'},
      {n:'128', name:'Sketch Card', artist:'Shaow Siong'},
      {n:'129', name:'Sketch Card', artist:'Solly Mohamed'},
      {n:'130', name:'Sketch Card', artist:'Steve Alce'},
      {n:'131', name:'Sketch Card', artist:'Thomas Amici'},
      {n:'132', name:'Sketch Card', artist:'Tim Shinn'},
      {n:'133', name:'Sketch Card', artist:'Tina Berardi'},
      {n:'134', name:'Sketch Card', artist:'Trent Westbrook'},
      {n:'135', name:'Sketch Card', artist:'Veronica Smith'},
      {n:'136', name:'Sketch Card', artist:'Vincenzo D\'Ippolito'},
      {n:'137', name:'Sketch Card', artist:'Ward Silverman'},
      {n:'138', name:'Sketch Card', artist:'Wayne Tully'},
      {n:'139', name:'Sketch Card', artist:'Zach Woolsey'},
    ]
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

export const PARALLELS = BASE_PARALLELS;
export const AUTO_PARALLELS = AUTO_LADDER;
export const INSERT_PARALLELS = INSERT_LADDER;
